import { Img } from '@chakra-ui/image'
import { Box, Text, VStack } from '@chakra-ui/layout'
import { SliderFilledTrack, SliderThumb, SliderTrack, Slider, SliderMark } from '@chakra-ui/slider'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/tabs'
import React, { useState } from 'react'
import { MdGraphicEq } from "react-icons/md";
import workimag2 from '../../assets/image/Home_How_it_works_2_d18efa6600.webp'
import workimag3 from '../../assets/image/Home_How_it_works_3_d3ad98a8b6.webp'
import workimag4 from '../../assets/image/Home_How_it_works_4_25ef22809f.webp'
import workimag5 from '../../assets/image/Home_How_it_works_5_5766a24eca.webp'
import behindthescenes from '../../assets/image/behindthescenes.webp'
import { contactnumber } from '../../lib/Constants'

const HowToWork = () => {
    const [tabIndex, setTabIndex] = useState(0)
    const [sliderValue, setSliderValue] = useState(0)
    const handleSliderChange = (event) => {
        setSliderValue(event)
        setTabIndex(event)
    }
    const handleTabsChange = (index) => {
        setTabIndex(index)
        setSliderValue(index)
    }
    return (
        <Box
            mx="auto"
            maxW={{ base: '100vw', sm: '100vw', md: '90vw', lg: '90vw', xl: '90vw' }}
            transition="0.5 ease-out"
        >
            <Box
                my="4rem"
                mx={{ base: '0', sm: '0rem', md: '2rem', lg: '2rem', xl: '2rem' }}>
                <Text
                    className='main-section'
                    textAlign="center"
                    color="#FB1923"
                    textTransform="uppercase"
                    fontWeight="bold"
                    fontSize="3xl"
                    letterSpacing="3px"
                >HOW IT WORKS</Text>
                <Box background="#FF1111" mt="3rem" p="1.5rem">
                    <Text
                        className='main-section'
                        fontSize="md"
                        letterSpacing='3px'
                        textTransform="uppercase"
                        fontWeight="bold"
                        lineHeight="22px"
                        color="#fff"
                        textAlign="center"
                    >Behind The Scenes INTO India's Fastest Medical Response</Text>
                </Box>
                <Box>

                    <Tabs className='work_tabs' index={tabIndex} onChange={handleTabsChange}>
                        <TabPanels>
                            <TabPanel outline="0!important" outlineOffset="0" p={0} bg='rgba(237, 242, 245, 1)'>
                                <Img bg='rgba(237, 242, 245, 1)' width="100%" alt='home' objectFit='contain!important'
                                    loading='lazy'
                                    src={behindthescenes} />
                            </TabPanel>
                            <TabPanel outline="0!important" outlineOffset="0" p={0}>
                                <Img width="100%" alt='home'
                                    loading='lazy'
                                    src={workimag2} />
                            </TabPanel>
                            <TabPanel outline="0!important" outlineOffset="0" p={0}>
                                <Img width="100%" alt='home'
                                    loading='lazy'
                                    src={workimag3} />
                            </TabPanel>
                            <TabPanel outline="0!important" outlineOffset="0" p={0}>
                                <Img width="100%" alt='home'
                                    loading='lazy'
                                    src={workimag4} />
                            </TabPanel>
                            <TabPanel outline="0!important" outlineOffset="0" p={0}>
                                <Img width="100%" alt='home'
                                    loading='lazy'
                                    src={workimag5} />
                            </TabPanel>
                        </TabPanels>
                        <Box
                            bg="#F7F7F7"
                            py={{ base: '1rem', sm: '1rem', md: '2rem', lg: '2rem', xl: '2rem' }}
                            px={{ base: '2rem', sm: '1rem', md: '1.5rem', lg: '3rem', xl: '3rem' }}>
                            <Box
                                display={{ base: 'bolck', sm: 'block', md: 'block', lg: 'flex', xl: 'flex' }}
                                alignItems="center">
                                <Text
                                    fontSize="xs"
                                    color="#979797"
                                    width={{ base: '100%', sm: '100%', md: '100%', lg: '120px', xl: '120px' }}
                                    textAlign={{ base: 'start', sm: 'start', md: 'start', lg: 'center', xl: 'center' }}
                                >Scroll</Text>
                                <Slider
                                    type='range'
                                    aria-label='slider-ex-4'
                                    min={0}
                                    max={4}
                                    step={1}
                                    value={sliderValue}
                                    onChange={(val) => handleSliderChange(val)}
                                    focusThumbOnChange={true}
                                >
                                    <SliderMark value={sliderValue} />
                                    <SliderTrack bg='gray.200'>
                                        <SliderFilledTrack bg='red.400' />
                                    </SliderTrack>
                                    <SliderThumb boxSize={6} >
                                        <Box color='gray.500' as={MdGraphicEq} />
                                    </SliderThumb>
                                </Slider>
                                <Text fontSize="xs" color="#979797" width={120}></Text>
                            </Box>
                            <TabList justifyContent="space-between" className='work_btn' borderBottom="none" >
                                <Tab>
                                    <VStack>
                                        <Text fontSize={14}>00:00 min</Text>
                                        <Text fontSize={12}>Emergency at home/ office/ road</Text>
                                        <Text as="b">{contactnumber}</Text>
                                    </VStack>
                                </Tab>
                                <Tab>
                                    <VStack>
                                        <Text fontSize={14}>1:00 min</Text>
                                        <Text fontSize={12}>Our dispatch centre finds you the nearest vehicle</Text>
                                        <Text as="b">Ambulance Dispatched</Text>
                                    </VStack>
                                </Tab>
                                <Tab>
                                    <VStack>
                                        <Text fontSize={14}>1:30 min</Text>
                                        <Text fontSize={12}>Get realtime notifications and messages</Text>
                                        <Text as="b">Track Your Help</Text>
                                    </VStack>
                                </Tab>
                                <Tab>
                                    <VStack>
                                        <Text fontSize={14}>4:10 mins</Text>
                                        <Text fontSize={12}>Connecting you to the right hospital</Text>
                                        <Text as="b">Hospital Informed</Text>
                                    </VStack>
                                </Tab>
                                <Tab>
                                    <VStack>
                                        <Text fontSize={14}>15 mins</Text>
                                        <Text fontSize={12}>Patient stabilized by HelpNow paramedics</Text>
                                        <Text as="b">Ambulance Arrives</Text>
                                    </VStack>
                                </Tab>
                            </TabList>
                        </Box>
                    </Tabs>
                </Box>
            </Box >
        </Box >
    )
}

export default HowToWork